import axios from "axios";

const CONFIGURE_API = "CONFIGURE_API";
const CLEAR_ERROR = "CLEAR_ERROR";
const SET_ERROR = "SET_ERROR";

const initialState = {
  axios: {},
  url: null,
  error: null,
};

const configureApi = ({ baseURL }) => {
  const config = {
    baseURL,
    headers: {
      Accept: "application/json",
    },
  };
  const _axios = axios.create(config);
  _axios.interceptors.request.use(
    (config) => config,
    (error) => Promise.reject(error)
  );
  // Add a response interceptor
  _axios.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
  );
  return _axios;
};

const mutations = {
  [CONFIGURE_API](state, { apiUrl }) {
    state.url = apiUrl;
    state.axios = Object.freeze(configureApi({ baseURL: apiUrl }));
  },
  [SET_ERROR](state, error) {
    error.timestamp = new Date().toLocaleString();
    if (error.response) {
      console.error(error.response);
    } else if (error.config) {
      console.error(error.config);
    } else {
      console.error(error);
    }
    state.error = error;
  },
  [CLEAR_ERROR](state) {
    state.error = null;
  },
};

const actions = {
  configureApi: ({ commit, state }, { apiUrl }) => {
    if (apiUrl !== state.url) {
      commit(CONFIGURE_API, { apiUrl });
    }
  },
  clearError: ({ commit }) => {
    commit(CLEAR_ERROR);
  },
  setError: ({ commit }, error) => {
    commit(SET_ERROR, error);
  },
};

const getters = {
  api(state) {
    return state.axios;
  },
  error(state) {
    return state.error;
  },
};

export default {
  namespaced: false,
  state: initialState,
  mutations,
  actions,
  getters,
};
